export default "__VITE_ASSET__CHDmGrGe__"